document.addEventListener('DOMContentLoaded', function () {
  const box = document.querySelector('.patch-customizer-box');
  if (!box) return;


  let I18N = {};
  try { I18N = JSON.parse(box.dataset.i18n || '{}'); } catch (e) { I18N = {}; }
  const t = (key, fallback) => I18N[key] || fallback;

  // ================== CONFIG ==================
  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
  const ALLOWED_TYPES = ['image/png', 'image/jpeg'];
  const MAX_CHARS = parseInt(box.dataset.maxChars, 10) || 22;
  const CURRENCY = box.dataset.currency || 'KD';
  // ============================================

  
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const DEFAULT_UPLOAD_TEXT = t('upload_image', 'Upload Image');
  const totalEl = document.getElementById('patch-total-display');

  function updateTotal() {
    let total = 0;
    box.querySelectorAll('.patch-checkbox:checked').forEach(cb => {
      total += parseFloat(cb.dataset.price) || 0;
    });
    total = Math.round(total * 1000) / 1000;
    if (totalEl) {
      totalEl.textContent = '+' + (total % 1 ? total.toFixed(3) : total) + ' ' + CURRENCY;
    }
  }


  function setupRow(row) {
    const pvDef = row.querySelector('.patch-preview-patch--default');
    const cb = row.querySelector('.patch-checkbox');
    const textIn = row.querySelector('.patch-text-input');  
    const counter = row.querySelector('.char-counter');
    const fileIn = row.querySelector('.patch-image-input');  
    const dz = row.querySelector('.upload-dropzone');
    const dzText = row.querySelector('.upload-text');
    const pvText = row.querySelector('.patch-preview-patch--text');
    const pvTextEl = row.querySelector('.patch-preview-text');
    const pvImg = row.querySelector('.patch-preview-patch--image');
    const pvImgEl = row.querySelector('.patch-preview-img');
    const clearBtn = row.querySelector('.patch-clear');

    const mode = textIn ? 'text' : 'image';
    let objectUrl = null;

    if (textIn) textIn.maxLength = MAX_CHARS;

    function renderCounter() {
      if (!textIn || !counter) return;
      counter.textContent = `${textIn.value.length}/${MAX_CHARS} ${t('characters', 'Characters')}`;
    }

    function showDefault() {
      pvDef.hidden = false;
      pvText.hidden = true;
      pvImg.hidden = true;
    }

    function renderPreview() {
      if (mode === 'text') {
        const v = textIn.value.trim();
        if (!v) {
          showDefault();
        } else {
          pvDef.hidden = true;
          pvText.hidden = false;
          pvImg.hidden = true;
          pvTextEl.textContent = v;
        }
      } else {
        const hasFile = !!(fileIn.files && fileIn.files.length);
        if (hasFile && objectUrl) {
          pvDef.hidden = true;
          pvText.hidden = true;
          pvImg.hidden = false;
        } else {
          showDefault();
        }
      }
    }

    function syncSelected() {
      const has = mode === 'text'
        ? textIn.value.trim().length > 0
        : !!(fileIn.files && fileIn.files.length);
      cb.checked = has;
      updateTotal();
    }

    function resetFile() {
      if (!fileIn) return;
      fileIn.value = '';
      if (dzText) dzText.textContent = DEFAULT_UPLOAD_TEXT;
      if (dz) {
        dz.classList.remove('has-file');
        const thumb = dz.querySelector('.upload-preview');
        if (thumb) thumb.remove();
      }
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        objectUrl = null;
      }
      pvImgEl.removeAttribute('src');
    }

    function resetText() {
      if (!textIn) return;
      textIn.value = '';
      renderCounter();
    }


    if (textIn) {
      textIn.addEventListener('input', function () {
        renderCounter();
        renderPreview();
        syncSelected();
      });
    }


    if (fileIn) {
      fileIn.addEventListener('change', function () {
        const file = this.files[0];
        if (!file) {
          resetFile();
          renderPreview();
          syncSelected();
          return;
        }
        if (!ALLOWED_TYPES.includes(file.type)) {
          alert(t('alert_file_type', 'Only PNG or JPG images are allowed.'));
          resetFile();
          renderPreview();
          syncSelected();
          return;
        }
        if (file.size > MAX_FILE_SIZE) {
          alert(t('alert_file_size', 'Image must be smaller than 2MB.'));
          resetFile();
          renderPreview();
          syncSelected();
          return;
        }

        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = URL.createObjectURL(file);

        dzText.textContent = file.name;
        dz.classList.add('has-file');

        let thumb = dz.querySelector('.upload-preview');
        if (!thumb) {
          thumb = document.createElement('img');
          thumb.className = 'upload-preview';
          thumb.alt = '';
          dz.insertBefore(thumb, dz.firstChild);
        }
        thumb.src = objectUrl;
        pvImgEl.src = objectUrl;

        renderPreview();
        syncSelected();
      });
    }


    clearBtn.addEventListener('click', function () {
      resetText();
      resetFile();
      renderPreview();
      syncSelected();
    });

    renderCounter();
    renderPreview();
  }

  box.querySelectorAll('.patch-option-row').forEach(setupRow);
  updateTotal();

  const addToCartBtn = document.querySelector('button[name="add"]');
  const patchAddBtn = document.getElementById('patch-add-btn');

  if (patchAddBtn) {
    patchAddBtn.addEventListener('click', function () {
      if (!box.querySelector('.patch-checkbox:checked')) {
        const firstInput = box.querySelector('.patch-text-input');
        if (firstInput) firstInput.focus();
        alert(t('alert_need_input', 'Please enter text or upload an image for your patch.'));
        return;
      }
      if (addToCartBtn) addToCartBtn.click();
    });
  }

  if (!addToCartBtn) return;

  addToCartBtn.addEventListener('click', async function (e) {
    
    const mainForm = addToCartBtn.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (!mainForm) return; 
    e.preventDefault();
    if (addToCartBtn.disabled) return;

    const mainVariantId = mainForm.querySelector('[name="id"]').value;
    const qty = mainForm.querySelector('[name="quantity"]')?.value || 1;

   
    const selected = [];
    for (const row of box.querySelectorAll('.patch-option-row')) {
      const cb = row.querySelector('.patch-checkbox');
      if (!cb.checked) continue;

      const label = cb.dataset.patchLabel;
      const labelDisplay = cb.dataset.patchLabelDisplay || label; 
      const addonVariantId = cb.dataset.addonVariantId;
      
      const textInput = row.querySelector('.patch-text-input');
      const fileInput = row.querySelector('.patch-image-input');
      const text = textInput ? textInput.value.trim() : '';
      const file = fileInput ? (fileInput.files[0] || null) : null;

      if (!addonVariantId) {
        alert(t('alert_addon_missing', 'Add-on variant is not set for one of the patches.'));
        return;
      }
      if (!text && !file) {
        alert(t('alert_add_text_or_image', 'Please add text or an image for "[label]".').replace('[label]', labelDisplay));
        return;
      }
      selected.push({ label, addonVariantId, text, file });
    }


    const originalBtnHTML = addToCartBtn.innerHTML;
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = selected.some(p => p.file)
      ? t('uploading', 'Uploading...')
      : t('adding', 'Adding...');

    try {
      const refId = 'patch-' + Date.now();


      const fd = new FormData();
      fd.append('id', mainVariantId);
      fd.append('quantity', qty);
      if (selected.length) fd.append('properties[_patch_ref]', refId);
      selected.forEach(p => {
        if (p.text) fd.append(`properties[${p.label} Text]`, p.text);
        if (p.file) fd.append(`properties[${p.label} Image]`, p.file, p.file.name);
      });

      const mainRes = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' }, 
        body: fd
      });
      const mainData = await mainRes.json().catch(() => ({}));
      if (!mainRes.ok) {
        throw new Error(mainData.description || mainData.message || t('err_product', 'Could not add product to cart'));
      }

      
      if (selected.length) {
        const addonItems = selected.map(p => ({
          id: parseInt(p.addonVariantId, 10),
          quantity: 1,
          properties: { 'Applies To': p.label, '_patch_ref': refId }
        }));

        const addonRes = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: addonItems })
        });
        const addonData = await addonRes.json().catch(() => ({}));

        if (!addonRes.ok) {
         
          if (mainData.key) {
            await fetch(ROOT + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: mainData.key, quantity: 0 })
            });
          }
          throw new Error(addonData.description || addonData.message || t('err_patch', 'Could not add patch to cart'));
        }
      }

      
      addToCartBtn.disabled = false;
      addToCartBtn.innerHTML = originalBtnHTML;

      if (window.theme && theme.miniCart) {
        theme.miniCart.updateElements(); 
        theme.miniCart.generateCart();   
        const miniCartEl = document.querySelector('.js-mini-cart');
        if (miniCartEl) miniCartEl.classList.add('active');
        
        box.querySelectorAll('.patch-clear').forEach(btn => btn.click());
      } else {
        window.location.href = ROOT + 'cart'; 
      }
    } catch (err) {
      console.error(err);
      alert(t('error_prefix', 'Error: ') + err.message);
      addToCartBtn.disabled = false;
      addToCartBtn.innerHTML = originalBtnHTML;
    }
  });
});


document.querySelectorAll('.remove-patch-link').forEach(btn => {
  btn.addEventListener('click', async function () {
    const keys = this.dataset.addonKeys.split(',').filter(k => k.trim() !== '');
    const mainLine = this.dataset.mainLine;

    try {
      if (mainLine) {
        
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        const targetItem = cartData.items[parseInt(mainLine, 10) - 1];

        if (targetItem) {
          const clearedProps = {};
          Object.keys(targetItem.properties || {}).forEach(key => {
            clearedProps[key] = null; 
          });

          const res1 = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: parseInt(mainLine, 10), properties: clearedProps })
          });
          const data1 = await res1.json();
          console.log('Properties clear response:', data1);
          if (!res1.ok) {
            alert('Error clearing properties: ' + JSON.stringify(data1));
            return;
          }
        }
      }

      
      if (keys.length > 0) {
        const updates = {};
        keys.forEach(key => { updates[key] = 0; });

        const res2 = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        const data2 = await res2.json();
        console.log('Addon remove response:', data2);
      }

      window.location.reload();
    } catch (err) {
      console.error('Caught error:', err);
      alert('Error: ' + err.message);
    }
  });
});


document.addEventListener('click', async function (e) {
  const link = e.target.closest('.js-cart-remove');
  if (!link) return;

  const addonKeys = (link.dataset.addonKeys || '').split(',').filter(k => k.trim() !== '');
  if (!addonKeys.length || !link.dataset.key) return;

  e.preventDefault();
  const updates = {};
  updates[link.dataset.key] = 0;
  addonKeys.forEach(k => { updates[k] = 0; });

  try {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!res.ok) throw new Error('Could not remove item');
    window.location.reload();
  } catch (err) {
    console.error(err);
    alert('Error: ' + err.message);
  }
});
